import type { TrainingFollowUpAttendanceSheetVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveAttendanceSheets = createApiThunk<TrainingFollowUpAttendanceSheetVM[], string>(
  "trainingFollowUps/adminRetrieveAttendanceSheets",
  async (trainingFollowUpId: string, { extra: { adminRepository } }) => {
    return adminRepository!.getAttendanceSheets(trainingFollowUpId);
  },
);
